import {SEND_COMMAND_STARTED} from "../../reducers/cleaningControlReducer";


export const sendCommandStarted = (namespace, pendingCommand) =>{
    return {
        type: namespace + SEND_COMMAND_STARTED,
        payload: {pendingCommand}
    }
}